import React from 'react';

const statusStyles = {
  draft: 'bg-slate-100 text-slate-700',
  active: 'bg-indigo-100 text-indigo-700',
  paused: 'bg-amber-100 text-amber-700',
  completed: 'bg-emerald-100 text-emerald-700',
};

const CampaignStatusBadge = ({ status }) => {
  const label = status
    ? status.charAt(0).toUpperCase() + status.slice(1)
    : 'Unknown';

  const classes = `text-xs font-medium px-2 py-0.5 rounded-full ${statusStyles[status] || 'bg-slate-100 text-slate-500'}`;

  return (
    <span
      className={classes}
      role="status"
      aria-label={`Campaign status: ${label}`}
      title={`Status: ${label}`}
    >
      {label}
    </span>
  );
};

export default CampaignStatusBadge;